import React from 'react';

const ModalClose = (
  <svg viewBox="0 0 24 24">
    <path d="M5 5l14 14m0-14L5 19" />
  </svg>
);

export default ModalClose;
